export { LeadsRegistryResponsibleCell } from './ui/LeadsRegistryResponsibleCell';
